import { useEffect, useState } from 'react';
import { useAnimationPreferences } from 'contexts/AnimationPreferencesContext';

const QUERY = '(prefers-reduced-motion: reduce)';

function osPrefersReduced(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(QUERY).matches;
}

/**
 * True when either the app's Reduce animations setting or the OS setting is
 * on (EN-11151 AC-7.2). Streak surfaces then show their still version.
 */
export function useStreakReducedMotion(): boolean {
  const { reduceAnimations } = useAnimationPreferences();
  const [os, setOs] = useState(osPrefersReduced);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setOs(mql.matches);
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);
  return reduceAnimations || os;
}
